"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApiUrl = exports.resolveJwtLoginField = exports.setJwtLoginField = exports.resolveAuthBaseUrl = exports.resolveApiBaseUrl = void 0;
const DEFAULT_API_BASE = 'http://127.0.0.1:8000/api/v1/';
const normalizeApiBaseUrl = (raw) => {
    const trimmed = (raw || '').trim();
    if (!trimmed) {
        return DEFAULT_API_BASE;
    }
    // Remove trailing slashes and any existing /api/v1 suffix.
    const withoutSlash = trimmed.replace(/\/+$/, '');
    const withoutApiV1 = withoutSlash.replace(/\/api\/v1\/?$/, '');
    return `${withoutApiV1}/api/v1/`;
};
const resolveApiBaseUrl = (env = process.env) => normalizeApiBaseUrl(env.REACT_APP_DF8_API_BASE_URL || env.PUBLIC_API_BASE || env.REACT_APP_API_BASE);
exports.resolveApiBaseUrl = resolveApiBaseUrl;
const resolveAuthBaseUrl = (env = process.env) => {
    const rawAuthBase = env.PUBLIC_AUTH_BASE || env.REACT_APP_PUBLIC_AUTH_BASE;
    if (rawAuthBase) {
        return rawAuthBase.replace(/\/+$/, '');
    }
    return (0, exports.resolveApiBaseUrl)(env).replace(/\/api\/v1\/$/, '');
};
exports.resolveAuthBaseUrl = resolveAuthBaseUrl;
let jwtLoginFieldOverride = null;
const setJwtLoginField = (field) => {
    jwtLoginFieldOverride = field ?? null;
};
exports.setJwtLoginField = setJwtLoginField;
const resolveJwtLoginField = (env = process.env) => {
    if (jwtLoginFieldOverride) {
        return jwtLoginFieldOverride;
    }
    const raw = env.REACT_APP_JWT_LOGIN_FIELD || '';
    return raw.toLowerCase() === 'email' ? 'email' : 'username';
};
exports.resolveJwtLoginField = resolveJwtLoginField;
const buildApiUrl = (path, env = process.env) => {
    const base = (0, exports.resolveApiBaseUrl)(env);
    const trimmedPath = path.replace(/^\/+/, '');
    const withoutApiV1 = trimmedPath.replace(/^api\/v1\/+/, '');
    return `${base}${withoutApiV1}`;
};
exports.buildApiUrl = buildApiUrl;
